import $ from "jquery";
import CONFIG from "@bd-core/config";

export default class Timer {
    constructor(timeoutCallback) {
        this.timeoutCursor = null;
        this.timeoutCallback = timeoutCallback;
        this.elms = {
            timer: ".js-timer-text",
            timerRemaining: ".js-timer .timer__remaining",
            popupHint: ".js-popup-timerhint",
        };
    }

    init() {
        // Don't run this on static page
        if (!CONFIG.game.cfgLimit) return false;

        /* register close events */
        const $popup = $(this.elms.popupHint);
        $popup.find(".js-close-hint").on("click", this.hideNotif.bind(this));

        let self = this;

        if (this.timeoutCursor) {
            clearInterval(this.timeoutCursor);
        }

        const getCurrentTime = () => new Date(Date.now()).getTime();
        const timeLimit = new Date(
            getCurrentTime() + CONFIG.game.timeLeft * 1000,
        );

        const cfgLimit = CONFIG.game.cfgLimit.timeLimit * 60 * 1000;
        const timeLeft = timeLimit.getTime() - getCurrentTime();

        const toTimeObject = (time) => {
            const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((time / 1000 / 60) % 60);
            const seconds = Math.floor((time / 1000) % 60);

            return {
                h: hours.toString().padStart(2, "0"),
                m: minutes.toString().padStart(2, "0"),
                s: seconds.toString().padStart(2, "0"),
            };
        };

        const updateTimer = (h, m, s, percent) => {
            const txtH = h !== "00" ? `${h}:` : "";
            let txtTimer = `${txtH}${m}:${s}`;

            percent = percent < 0 ? 0 : percent;

            $(self.elms.timer).text(txtTimer);
            $(self.elms.timerRemaining).css("width", percent + "%");
        };

        if (timeLeft <= 0) {
            updateTimer("00", "00", "00", "100");
            return false;
        }

        if (CONFIG.game.isFinish || CONFIG.game?.game_prop?.disableTimer) {
            const objTime = toTimeObject(timeLeft);
            const percentage = (100 * timeLeft) / cfgLimit;

            updateTimer(objTime.h, objTime.m, objTime.s, percentage);

            return false;
        }

        this.timeoutCursor = setInterval(() => {
            const time = timeLimit.getTime() - getCurrentTime();
            const percentage = (100 * time) / cfgLimit;
            const objTimer = toTimeObject(time);

            $.each(CONFIG.game.cfgLimit.notifications, function (index, item) {
                const hours = Math.floor(item.inMinutesLeft / 60)
                    .toString()
                    .padStart(2, "0");
                const minutes = Math.floor(item.inMinutesLeft % 60)
                    .toString()
                    .padStart(2, "0");

                if (
                    objTimer.h == hours &&
                    minutes == objTimer.m &&
                    objTimer.s == "00"
                ) {
                    self.showNotif(item.title, item.text);
                    CONFIG.game.cfgLimit.notifications.splice(index, 1);
                    return false;
                }
            });

            updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);

            if (time <= 0) {
                if (self.timeoutCursor) {
                    clearInterval(self.timeoutCursor);
                }

                if (typeof self.timeoutCallback == "function")
                    self.timeoutCallback();
            }
        }, 1000);

        // Perform timer calculation immediately before the interval
        const time = timeLimit.getTime() - getCurrentTime();
        const objTimer = toTimeObject(time);
        const percentage = (100 * time) / cfgLimit;
        updateTimer(objTimer.h, objTimer.m, objTimer.s, percentage);

        return this;
    }

    showNotif(title, text) {
        const $popup = $(this.elms.popupHint);

        $popup.find(".js-hint-title").text(title);
        $popup.find(".js-hint-content").html(text);
        $popup.addClass("is-open");
    }

    hideNotif() {
        const $popup = $(this.elms.popupHint);
        $popup.removeClass("is-open");
    }

    stopTimer() {
        if (CONFIG.game.isFinish) {
            clearInterval(this.timeoutCursor);
        }
    }
}
